import { useMsal } from '@azure/msal-react'
import { Box, useMediaQuery } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Outlet, useNavigate } from 'react-router-dom'

import { updateUserLanguage } from '../api/services/apiService'
import theme from '../theme'
import { useUserDetails } from '../user/hooks/user.hooks'
import AppTopBar from './AppBar/AppTopBar'

const TopBarOnlyLayout = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { instance, accounts } = useMsal()
  const isSmallDown = useMediaQuery(theme.breakpoints.down('sm'))
  const userDetails = useUserDetails()

  const handleLogout = () => {
    instance.logoutRedirect({ account: accounts[0] })
  }

  const menuItems = [
    {
      title: t('otherLanguage'),
      action() {
        const newLanguage = i18n.language === 'fr' ? 'en' : 'fr'
        i18n.changeLanguage(newLanguage)
        updateUserLanguage(newLanguage)
      },
    },
    { title: t('userSettings'), action: () => navigate('/UserSettings') },
    ...(userDetails?.isAdmin ? [{ title: t('admin'), action: () => navigate('/admin') }] : []),
    { title: t('logout'), action: handleLogout },
  ]

  return (
    <>
      <AppTopBar onMenuClick={() => {}} onSiteClick={() => {}} isSmallDown={isSmallDown} showHamburger={false} desktopOpen={false} menuItems={menuItems} />
      <Box sx={{ paddingTop: '64px' }}>
        <Outlet />
      </Box>
    </>
  )
}

export default TopBarOnlyLayout
